module.exports = function() {
  return new Worker(__webpack_public_path__ + "0dd6641be005676ccdc4.worker.js");
};